import { AgenciesApiException } from '@urbanx/agx.agencies.client';
import { getApiErrorStatus } from '@urbanx/agx.auth.client';

export const requiresAgentSaveReload = (error: unknown, creating: boolean): boolean => {
  const status =
    getApiErrorStatus(error) ?? (error instanceof AgenciesApiException ? error.status : undefined);
  if (
    status !== undefined &&
    status >= 400 &&
    status < 500 &&
    ![408, 409, 412, 499].includes(status)
  )
    return false;

  // CreateAgent's declared string error is validation. Update strings can also
  // represent conflicts or partial saves, and no longer carry their HTTP status.
  return !(creating && typeof error === 'string' && error.trim());
};
